const steps = [
  {
    num: '1',
    title: 'Диагностика',
    desc: 'Изучаем реальные управленческие задачи, ожидания бизнеса и текущий уровень руководителей. Проводим интервью, собираем обратную связь, анализируем типичные ситуации.',
  },
  {
    num: '2',
    title: 'Настройка программы',
    desc: 'Адаптируем содержание под компанию, отрасль и уровень руководителей. Используем реальные кейсы и управленческие ситуации, с которыми сталкиваются участники.',
  },
  {
    num: '3',
    title: 'Практическое обучение',
    desc: 'Минимум теории ради теории. Инструменты отрабатываются в упражнениях, ролевых ситуациях и на реальных кейсах компании. 70-80% времени — практика.',
  },
  {
    num: '4',
    title: 'Отработка',
    desc: 'Участники тренируются применять инструменты в управленческих ситуациях. Получают обратную связь от тренера и коллег, корректируют подходы.',
  },
  {
    num: '5',
    title: 'Внедрение',
    desc: 'Инструменты переносятся в ежедневную управленческую практику. Участники получают алгоритмы, чек-листы и шаблоны для использования в работе.',
  },
  {
    num: '6',
    title: 'Сопровождение',
    desc: 'При необходимости продолжаем работу с командой: разбираем реальные ситуации после тренинга, помогаем закрепить навыки и преодолеть трудности внедрения.',
  },
  {
    num: '7',
    title: 'Оценка изменений',
    desc: 'Через 1-3 месяца определяем, какие изменения произошли в управленческой практике и бизнес-показателях: как изменилась постановка задач, снизился ли микроменеджмент, улучшилось ли качество обратной связи.',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          От обучения к изменению управленческого поведения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Мы не проводим тренинг ради тренинга. Наша цель — чтобы руководители начали управлять по-другому: ставить задачи понятнее, делегировать ответственность, давать конструктивную обратную связь.
        </p>

        <div className="relative">
          <div className="absolute left-6 md:left-8 top-8 bottom-8 w-0.5 bg-teal-200 hidden md:block"></div>

          <div className="space-y-6 md:space-y-8">
            {steps.map((step, i) => (
              <div key={i} className="relative flex gap-5 md:gap-8 items-start">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-teal-600 text-white rounded-xl flex items-center justify-center flex-shrink-0 relative z-10 shadow-md">
                  <span className="text-xl md:text-2xl font-extrabold">{step.num}</span>
                </div>
                <div className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 flex-grow">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}